import { Application } from "@hotwired/stimulus"

const application = Application.start()

application.debug = false
// Los bundles secundarios (editor, charts) se registran contra esta misma
// instancia en vez de arrancar una propia.
window.Stimulus = application
document.dispatchEvent(new CustomEvent("stimulus:ready"))

export { application }
